module.exports = __webpack_public_path__ + "622131cfe6d15de5c95fa1f68c53e940.pdf";